// 前端页面与导航的权限口径：与后端 permission-catalog.ts / permissions.ts 保持一致。
// 抽成模块的原因：原先 main.ts（路由守卫）和 App.vue（左侧导航）各写了一份映射，
// 新增一个权限码要改两处，很容易只改一边导致"菜单能看见、点进去 403"。
import { allows } from "./composables/useAuth";

// 每个页面 key 需要的权限；数组表示"任一满足即可"。
// 系统配置里拆出了用户/角色/部门/权限四块，所以只要拥有其中一块的读权限就能进入该页（页内再按 tab 收敛）。
export const routePermissions: Record<string, string | string[]> = {
  // 一眼判断"能不能进这个页面"用「功能」层（X.page）；页面内的列表/详情/按钮各自再判
  dashboard: "dashboard.page",
  duty: "duty.page",
  // 风险事件已并入任务中心：只有「任务」权限或只有「历史风险事件」权限的人，都能进任务中心
  tasks: ["task.page", "event.page"],
  risk: "risk.page",
  approvals: "approval.page",
  audit: "audit.page",
  notifications: ["telegram.chat.page", "telegram.group.page", "telegram.broadcast.page", "telegram.command.page", "notice.page"],
  files: "file.page",
  // 「文档中心」已并入文件管理（/documents 只是重定向到 /files），页面 key 不再注册；
  // document.* 这几个权限码后端照旧在用（/api/documents 原样保留），只是前端没有单独的页面了。
  office: [
    "office.overview.page",
    "office.expense.page", "office.purchase.page", "office.asset.page",
    "office.attendance.page", "office.calendar.page", "office.payroll.page"
  ],
  reports: "report.page",
  settings: ["settings.page", "user.page", "role.page", "department.page", "permission.page"]
};

/** 能不能看某个模块的详情（详情弹框、预览、下载、展开内容都用它） */
export function canSeeDetail(user: unknown, area: string) {
  return allows(user as never, `${area}.detail`);
}

export function allowsAny(user: unknown, permission: string | string[] | undefined) {
  if (!permission) return true;
  if (Array.isArray(permission)) return permission.some(item => allows(user as never, item));
  return allows(user as never, permission);
}

export function firstAllowedRoute() {
  return Object.keys(routePermissions).find(name => allowsAny(undefined, routePermissions[name])) ?? "me";
}
